import Switch from '@mui/material/Switch';
import { useEffect, useState } from 'react';

type Props = {
  initial: boolean;
  disabled: boolean;
  color: string;
  onToggleChange: (checked: boolean) => void;
};

const Toggle = ({ initial, disabled, color, onToggleChange }: Props) => {
  const [isChecked, setIsChecked] = useState(initial);
  const disabledColor = '#45a7353d';
  const switchOffColor = '#849095';
  useEffect(() => {
    setIsChecked(initial);
  }, [initial]);
  const handleChange = (_event, checked) => {
    setIsChecked(checked);
    onToggleChange(checked);
  };
  return (
    <Switch
      checked={isChecked}
      disabled={disabled}
      inputProps={{ 'aria-label': 'controlled' }}
      sx={{
        '& .MuiSwitch-thumb': {
          backgroundColor: disabled
            ? disabledColor
            : isChecked
            ? color
            : switchOffColor,
        },
        '& .MuiSwitch-track': {
          backgroundColor: isChecked || disabled ? color : switchOffColor,
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: isChecked || disabled ? color : switchOffColor,
        },
      }}
      onChange={handleChange}
    />
  );
};

export default Toggle;
